export default __webpack_public_path__ + "locales/az/EmptyTrashDialog.json?hash=ce110a9917bcd5f5b2d5b55450f07033";